import * as React from 'react';
import {Query} from 'react-apollo';

import gql from 'graphql-tag';

import type {OutcomeType} from 'nutshell-graphql-types';
import type {
    OutcomesSelect as OutcomesSelectQuery,
    OutcomesSelectVariables as OutcomesSelectQueryVariables,
} from 'nutshell-graphql-types';

import {GraphQLSelect} from '../../core/select/graphql-select';

type OwnProps = {
    outcomeTypes: OutcomeType[];
    onChange: (newValue: any) => any;
    selectedId: string | null | undefined;
};

// Basic query to get all closed and cancelled outcomes
const GET_OUTCOMES = gql`
    query OutcomesSelect($type: [OutcomeType!]) {
        outcomes(type: $type) {
            id
            name
            type
        }
    }
`;

class OutcomeQuery extends Query<OutcomesSelectQuery, OutcomesSelectQueryVariables> {}

export const OutcomesSelect = (props: OwnProps) => (
    <OutcomeQuery query={GET_OUTCOMES} variables={{type: props.outcomeTypes}}>
        {({data, loading}) => {
            const outcomes = data ? data.outcomes : null;

            return (
                <GraphQLSelect
                    {...props}
                    models={outcomes ? outcomes : []}
                    isLoading={loading}
                    placeholder='Choose an outcome…'
                />
            );
        }}
    </OutcomeQuery>
);
